export default function RegistrationBackground({ children }) {
    return (
        <div
            className="min-h-screen flex items-center justify-center px-4 py-20 relative"
            style={{
                backgroundImage: 'url(/assets/images/background/registration.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <div className="absolute inset-0 bg-black/50" />

            <div className="relative z-10 w-full flex justify-center">
                {children}
            </div>
        </div>
    );
}